/**
 * Formats a number to two decimal places, using locale string formatting.
 * @param num The number to format.
 * @returns The formatted number as a string.
 */
export function formatNumber(num: number): string {
    return Number(num).toLocaleString(undefined, { maximumFractionDigits: 2, minimumFractionDigits: 2 });
}
